import type { CpvNode } from "./cpvHierarchy";

export function filterCpvTree(tree: CpvNode[], query: string): CpvNode[] {
  const q = query.trim().toLowerCase();
  if (q === "") return [];

  function matches(node: CpvNode): boolean {
    return (
      node.code.toLowerCase().includes(q) ||
      node.nameEn.toLowerCase().includes(q) ||
      node.nameNb.toLowerCase().includes(q)
    );
  }

  function walk(nodes: CpvNode[]): CpvNode[] {
    const out: CpvNode[] = [];
    for (const node of nodes) {
      const matchingChildren = walk(node.children);
      if (matches(node) || matchingChildren.length > 0) {
        out.push({ ...node, children: matchingChildren });
      }
    }
    return out;
  }

  return walk(tree);
}
